import { ReactNode } from 'react';

export enum InfoHintType {
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
  Muted = 'muted'
}

export type IconType = 'error' | 'warning' | 'info' | 'success' | 'danger' | 'muted';

export interface InfoHintProps {
  children: ReactNode;
  className?: string;
  type?: IconType | InfoHintType;
  iconSize?: number;
  iconColor?: string;
  customIcon?: ReactNode;
}
